<div class="app-container" *ngIf="authService.user$ | async as user; else publicView" >
  <!-- Header Superior con Botón de Toggle -->
   
  <ng-container *ngIf="user.role !== 'client'">
  <header *ngIf="authService.user$ | async" class="app-header shadow-sm">
    <div class="d-flex align-items-center">
      <!-- Botón Toggle -->
      <button class="btn btn-toggle me-3" (click)="toggleSidebar()" title="Alternar menú">
        <i class="bi bi-list fs-4"></i>
      </button>
      
      <img src="assets/logo.png" alt="Logo" class="logo">
      <h2 class="h5 mb-0 d-none d-md-block" style="font-family: 'ServiTrackFont', sans-serif;">ServiTrack</h2>
      
      <!-- Tabs del Header -->
      <nav class="ms-4 d-none d-lg-flex">
        <button class="btn btn-nav" routerLink="/home" routerLinkActive="active">
          <i class="bi bi-house-fill me-1"></i> Inicio
        </button>
        <button class="btn btn-nav" routerLink="/dashboard" routerLinkActive="active">
          <i class="bi bi-tools me-1"></i> Servicios Activos
        </button>
        <button class="btn btn-nav" routerLink="/ready" routerLinkActive="active">
          <i class="bi bi-check-circle-fill me-1"></i> Órdenes Listas
        </button>
        <button class="btn btn-nav" routerLink="/history" routerLinkActive="active">
          <i class="bi bi-archive-fill me-1"></i> Historial
        </button>
        <button class="btn btn-nav" routerLink="/clients" routerLinkActive="active">
          <i class="bi bi-people-fill me-1"></i> Clientes
        </button>
      </nav>
    </div>

    <div class="d-flex align-items-center">
      <span class="me-3 d-none d-sm-inline text-light small">{{ (authService.user$ | async)?.email }}</span>
      <button class="btn btn-outline-light btn-sm" (click)="handleLogout()">
        <i class="bi bi-box-arrow-right me-1"></i> Salir
      </button>
    </div>
  </header>

   <div class="main-layout">
    <!-- Sidebar Desplegable -->
    <aside *ngIf="authService.user$ | async" 
           class="app-sidebar shadow" 
           [class.collapsed]="isSidebarCollapsed">
      
      <nav class="sidebar-nav">
        <!-- SECCIÓN DE NEGOCIO (Solo para Managers) -->

        <!-- SECCIÓN DE OPERACIONES -->
        <div class="nav-section-title mt-3" *ngIf="!isSidebarCollapsed">Operaciones</div>
        
        <a class="sidebar-link" routerLink="/home" routerLinkActive="active" title="Inicio">
          <i class="bi bi-speedometer2"></i>
          <span *ngIf="!isSidebarCollapsed">Inicio</span>
        </a>
        
        <a class="sidebar-link" routerLink="/dashboard" routerLinkActive="active" title="Servicios Activos">
          <i class="bi bi-tools"></i>
          <span *ngIf="!isSidebarCollapsed">Servicios Activos</span>
        </a>
        
        <a class="sidebar-link" routerLink="/ready" routerLinkActive="active" title="Órdenes Listas">
          <i class="bi bi-check2-all"></i>
          <span *ngIf="!isSidebarCollapsed">Órdenes Listas</span>
        </a>
        
        <a class="sidebar-link" routerLink="/history" routerLinkActive="active" title="Historial">
          <i class="bi bi-clock-history"></i>
          <span *ngIf="!isSidebarCollapsed">Historial</span>
        </a>

        <a class="sidebar-link" routerLink="/inspecciones" routerLinkActive="active" title="Inspecciones Técnicas">
          <i class="bi bi-card-checklist"></i>
          <span *ngIf="!isSidebarCollapsed">Inspecciones</span>
        </a>
        <a class="sidebar-link" routerLink="/appointments" routerLinkActive="active" title="Agenda y citas">
          <i class="bi bi-calendar-x"></i>
          <span *ngIf="!isSidebarCollapsed">Agenda y citas</span>
        </a>
        <div class="nav-section-title" *ngIf="!isSidebarCollapsed">Negocio</div>
          <ng-container *ngIf="authService.isManager$ | async">
          
          <a class="sidebar-link analytics-link" routerLink="/analytics" routerLinkActive="active" title="Analítica General">
            <i class="bi bi-pie-chart-fill"></i>
            <span *ngIf="!isSidebarCollapsed">Analítica General</span>
          </a>

       <a class="sidebar-link comisiones-link" routerLink="/comisiones" routerLinkActive="active" title="Com General">
  <i class="bi bi-wallet2"></i>
  <span *ngIf="!isSidebarCollapsed">Comisiones</span>
</a>
        </ng-container>
         <a class="sidebar-link" routerLink="/inventory" routerLinkActive="active">
          <i class="bi bi-box-seam"></i>
          <span *ngIf="!isSidebarCollapsed">Inventario</span>
        </a>

        <div class="nav-section-title mt-3" *ngIf="!isSidebarCollapsed">Administración</div>
        
        <a class="sidebar-link" routerLink="/clients" routerLinkActive="active" title="Gestionar Clientes">
          <i class="bi bi-person-rolodex"></i>
          <span *ngIf="!isSidebarCollapsed">Gestionar Clientes</span>
        </a>
        
        <div class="sidebar-footer mt-auto p-3 text-center text-muted small" *ngIf="!isSidebarCollapsed">
          v1.6 - ServiTrack
        </div>
      </nav>
    </aside>

    <!-- Contenido Principal -->
      <main class="app-content">
        <router-outlet></router-outlet>
      </main>
    </div>
  </ng-container>

  <!-- Si es un CLIENTE logueado, le quitamos todo el marco administrativo -->
  <ng-container *ngIf="user.role === 'client'">
    <main class="portal-only">
      <router-outlet></router-outlet>
    </main>
  </ng-container>
</div>

<ng-template #publicView>
  <router-outlet></router-outlet>
</ng-template>